/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {Observable} from "rxjs";
import {Injectable, Injector} from "@angular/core";
import {HttpEvent} from "@angular/common/http";
import {ApiServiceBase} from "../../api-service-base";
import {ControlPanel} from "../model/control-panel";
import {ControlPanelLocation} from "../model/control-panel-location";
import {PositionControlPanelRequest} from "../model/position-control-panel-request";
import {ResizeControlPanelRequest} from "../model/resize-control-panel-request";
import {SetControlPanelDockedStateRequest} from "../model/set-control-panel-docked-state-request";
import {SetControlPanelHiddenStateRequest} from "../model/set-control-panel-hidden-state-request";
import {SetControlPanelOpenStateRequest} from "../model/set-control-panel-open-state-request";
import {SetPanelOrderRequest} from "../model/set-panel-order-request";
import {UpdateControlPanelDefaultsRequest} from "../model/update-control-panel-defaults-request";

@Injectable({
    providedIn: "root",
})
export class SimUserInterfaceService extends ApiServiceBase {
	constructor(injector: Injector) {
        super(injector);
	}
    public getAllControlPanelDefaults() {
        return super.get<ControlPanel[]>(`/api/UserInterface/GetAllControlPanelDefaults`, );
    }

    public getControlPanels(location: ControlPanelLocation) {
        return super.get<ControlPanel[]>(`/api/UserInterface/GetControlPanels`, {location: location});
    }

    public positionControlPanel(request: PositionControlPanelRequest) {
        return super.post<boolean>(`/api/UserInterface/PositionControlPanel`, request);
    }

    public resizeControlPanel(request: ResizeControlPanelRequest) {
        return super.post<boolean>(`/api/UserInterface/ResizeControlPanel`, request);
    }

    public restorePanels(location: ControlPanelLocation) {
        return super.get<ControlPanel[]>(`/api/UserInterface/restorePanels`, {location: location});
    }

    public setControlPanelDockedState(request: SetControlPanelDockedStateRequest) {
        return super.post<boolean>(`/api/UserInterface/SetControlPanelDockedState`, request);
    }

    public setControlPanelHiddenState(request: SetControlPanelHiddenStateRequest) {
        return super.post<boolean>(`/api/UserInterface/SetControlPanelHiddenState`, request);
    }

    public setControlPanelOpenState(request: SetControlPanelOpenStateRequest) {
        return super.post<boolean>(`/api/UserInterface/SetControlPanelOpenState`, request);
    }

    public setPanelOrder(request: SetPanelOrderRequest) {
        return super.post<boolean>(`/api/UserInterface/SetPanelOrder`, request);
    }

    public updateControlPanelDefaults(request: UpdateControlPanelDefaultsRequest) {
        return super.post<boolean>(`/api/UserInterface/UpdateControlPanelDefaults`, request);
    }
}